import { render, staticRenderFns } from "./AddStoneMake.vue?vue&type=template&id=369d93cb&"
import script from "./AddStoneMake.vue?vue&type=script&lang=js&"
export * from "./AddStoneMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports